import React, { useEffect, useState } from 'react';
import Footer from './common/home/Footer';
import TopBar from './common/home/TopBar';
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { homeBackground } from './common/ColorCodes';
import PriceCalculatorApiService from '../services/PriceCalculatorApiService';
import DebugService from '../services/DebugService';
import DataGridTable from './common/DataGridTable';
import { CONST_SITE_LABEL } from './common/Helper';

export const CloudEstimator = () => {

  const [service, setService] = useState('EC2')
  const [priceList, setPriceList] = useState([])
  const [regionList, setRegionList] = useState([''])
  const [tenancyList, setTenancyList] = useState([''])
  const [operatingSystemList, setOperatingSystemList] = useState([''])
  const [instanceFamilyList, setInstanceFamilyList] = useState([''])
  const [vcpuList, setVCPUList] = useState([''])
  const [memoryList, setMemoryList] = useState([''])
  const [networkPerformanceList, setNetworkPerformanceList] = useState([''])
  const [databaseEngineList, setDatabaseEngineList] = useState([''])
  const [clusterConfigurationList, setClusterConfigurationList] = useState([''])
  const [deploymentOptionList, setDeploymentOptionList] = useState([''])
  const [instanceTypeList, setInstanceTypeList] = useState([''])
  const [storageClassList, setStorageClassList] = useState([''])
  const [storageTypeList, setStorageTypeList] = useState([''])
  const [storageUnitList, setStorageUnitList] = useState([''])
  const [storageOnDemandCost, setstorageOnDemandCost] = useState(0)
  const [storageOnDemandMonthlyCost, setstorageOnDemandMonthlyCost] = useState(0)
  const [EBSTotalInstanceHours, setEBSTotalInstanceHours] = useState(0)
  const [EBSStorage, setEBSStorage] = useState(0)
  const [EBSOndemandCost, setEBSOndemandCost] = useState(0)
  const [EBSStorageCost, setEBSStorageCost] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [calculateForm, setCalculateForm] = useState({
    region: 'Asia Pacific (Mumbai)',
    instanceName: '',
    selInstanceFamily: '',
    selVCPU: '',
    selMemory: '',
    selNetworkPerformace: '',
    tenancy: 'Shared',
    operatingSystem: 'Linux',
    databaseEngine: 'MySQL',
    deploymentOption: 'Multi-AZ',
    rdsInstanceType: '',
    clusterConfiguration: '',
    storageClass: '',
    storageAmount: 0,
    storageUnit: '',
    storageType: 'General Purpose SSD (gp2)',
    volumes: 1,
    volumeDuration: 730,
    volumeDurationUnit: 'hours per month'
  })

  const serviceList = [
    { label: 'EC2', value: 'EC2' },
    { label: 'RDS', value: 'RDS' },
    { label: 'S3', value: 'S3' },
    { label: 'EBS', value: 'EBS' },
  ]

  const ec2ColumnList = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
      align: 'center'
    },
    {
      field: 'instanceType',
      headerName: 'Instance Type',
      flex: 1,
      align: 'center'
    },
    {
      field: 'vcpu',
      headerName: 'vCPUs',
      flex: 1,
      align: 'center'
    },
    {
      field: 'memory',
      headerName: 'Memory',
      flex: 1,
      align: 'center'
    },
    {
      field: 'networkPerformance',
      headerName: 'Network Performance',
      flex: 1,
      align: 'center'
    },
    {
      field: 'storage',
      headerName: 'Storage',
      flex: 1,
      align: 'center'
    },
    {
      field: 'currentGeneration',
      headerName: 'Current Generation',
      flex: 1,
      align: 'center'
    },
    {
      field: 'instanceHourlyCost',
      headerName: 'On Demand Hourly Cost',
      flex: 1,
      align: 'center'
    },
    {
      field: 'instanceMonthlyCost',
      headerName: 'On Demand Monthly Cost',
      flex: 1,
      align: 'center'
    },
  ]

  const rdsColumnList = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
      align: 'center'
    },
    {
      field: 'instanceType',
      headerName: 'Instance Type',
      flex: 1,
      align: 'center'
    },
    {
      field: 'vcpu',
      headerName: 'vCPUs',
      flex: 1,
      align: 'center'
    },
    {
      field: 'memory',
      headerName: 'Memory',
      flex: 1,
      align: 'center'
    },
    {
      field: 'deploymentOption',
      headerName: 'Deployment Option',
      flex: 1,
      align: 'center'
    },
    {
      field: 'storage',
      headerName: 'Storage',
      flex: 1,
      align: 'center'
    },
    {
      field: 'currentGeneration',
      headerName: 'Current Generation',
      flex: 1,
      align: 'center'
    },
    {
      field: 'instanceHourlyCost',
      headerName: 'On Demand Hourly Cost',
      flex: 1,
      align: 'center'
    },
    {
      field: 'instanceMonthlyCost',
      headerName: 'On Demand Monthly Cost',
      flex: 1,
      align: 'center'
    },
  ]

  /**
   * On reset handler
   */
  const onReset = () => {
    setCalculateForm({
      region: 'Asia Pacific (Mumbai)',
      instanceName: '',
      selInstanceFamily: '',
      selVCPU: '',
      selMemory: '',
      selNetworkPerformace: '',
      tenancy: 'Shared',
      operatingSystem: 'Linux',
      databaseEngine: 'MySQL',
      deploymentOption: 'Single-AZ',
      rdsInstanceType: '',
      clusterConfiguration: '',
      storageClass: '',
      storageAmount: service === 'EBS' ? 30 : 0,
      storageUnit: service === 'EBS' ? 'GB' : '',
      storageType: 'General Purpose SSD (gp2)',
      volumes: 1,
      volumeDuration: 730,
      volumeDurationUnit: 'hours per month'
    })
  }

  /**
   * Fetch price list
   */
  const fetchPriceList = () => {
    setIsLoading(true)

    const requestData = {
      location: calculateForm['region']
    }

    if (service === 'EC2') {
      requestData['operatingSystem'] = calculateForm['operatingSystem']
      requestData['tenancy'] = calculateForm['tenancy']
      requestData['vcpu'] = calculateForm['selVCPU']
      requestData['instanceType'] = calculateForm['instanceName']
      requestData['instanceFamily'] = calculateForm['selInstanceFamily']
      requestData['memory'] = calculateForm['selMemory']
      requestData['networkPerformance'] = calculateForm['selNetworkPerformace']

    } else if (service === 'RDS') {
      requestData['databaseEngine'] = calculateForm['databaseEngine']
      requestData['deploymentOption'] = calculateForm['deploymentOption']
      requestData['instanceType'] = calculateForm['rdsInstanceType']
      requestData['vcpu'] = calculateForm['selVCPU']
      requestData['instanceFamily'] = calculateForm['selInstanceFamily']
      requestData['memory'] = calculateForm['selMemory']

      if (["Aurora PostgreSQL", "Aurora MySQL"].includes(calculateForm['databaseEngine'])) {
        requestData['storage'] = calculateForm['clusterConfiguration']
      }

    } else if (service === 'S3') {
      requestData['storageClass'] = calculateForm['storageClass']
      requestData['pricingUnit'] = calculateForm['storageUnit']
      requestData['storageAmount'] = calculateForm['storageAmount']

    } else if (service === 'EBS') {
      requestData['storageType'] = calculateForm['storageType']
      requestData['volumeDuration'] = calculateForm['volumeDuration']
      requestData['volumeDurationUnit'] = calculateForm['volumeDurationUnit']
      requestData['storageAmount'] = calculateForm['storageAmount']
      requestData['storageAmountUnit'] = calculateForm['storageUnit']
      requestData['volumes'] = calculateForm['volumes']

    }

    PriceCalculatorApiService.getPriceList(service, requestData)
      .then(res => {
        DebugService.log(`Price Calculator Component: ${service} Price List API response`, res)
        const apiData = res['data'] ?? []

        if (service === 'EBS') {
          setEBSStorage(apiData[0]['storageInGB'] ?? 0)
          setEBSOndemandCost(apiData[0]['ebsOndemandCost'] ?? 0)
          setEBSStorageCost(apiData[0]['ebsStorageCost'] ?? '')

        } else if (service === 'S3') {
          setstorageOnDemandCost(apiData[0]['storageOndemandCost'] ?? 0)
          setstorageOnDemandMonthlyCost(apiData[0]['storageOndemandMonthlyCost'] ?? 0)

        } else {
          setPriceList(apiData)
        }

        if (res['error']) {
          DebugService.error(`Price Calculator Component: Error caught while fetching ${service} price list`, res['error'])
        }

        setIsLoading(false)
      })
      .catch(err => {
        DebugService.error(`Price Calculator Component: Error caught while fetching ${service} price list`, err)
        setIsLoading(false)
      })
  }

  /**
   * Fetch filter list for selected service
   */
  const fetchFilters = () => {
    setIsLoading(true)

    PriceCalculatorApiService.getFilters(service)
      .then(res => {
        DebugService.log(`Price Calculator Component: ${service} Filters API response`, res)
        const apiData = res['data'] ?? {}

        // EC2 Filters
        if (apiData['networkPerformance'] && apiData['networkPerformance'].length > 0) {
          setNetworkPerformanceList(apiData['networkPerformance'])
        }
        if (apiData['operatingSystem'] && apiData['operatingSystem'].length > 0) {
          setOperatingSystemList(apiData['operatingSystem'])
        }
        if (apiData['tenancy'] && apiData['tenancy'].length > 0) {
          setTenancyList(apiData['tenancy'])
        }

        // EC2,EBS and RDS Common filters
        if (apiData['location'] && apiData['location'].length > 0) {
          setRegionList(apiData['location'])
        }

        // EC2 and RDS Common filters
        if (apiData['vcpu'] && apiData['vcpu'].length > 0) {
          setVCPUList(apiData['vcpu'])
        }
        if (apiData['memory'] && apiData['memory'].length > 0) {
          setMemoryList(apiData['memory'])
        }
        if (apiData['instanceFamily'] && apiData['instanceFamily'].length > 0) {
          setInstanceFamilyList(apiData['instanceFamily'])
        }

        // RDS Filters
        if (apiData['instanceType'] && apiData['instanceType'].length > 0) {
          setInstanceTypeList(apiData['instanceType'])
        }
        if (apiData['databaseEngine'] && apiData['databaseEngine'].length > 0) {
          setDatabaseEngineList(apiData['databaseEngine'])
        }
        if (apiData['deploymentOption'] && apiData['deploymentOption'].length > 0) {
          setDeploymentOptionList(apiData['deploymentOption'])
        }
        if (apiData['storage'] && apiData['storage'].length > 0) {
          setClusterConfigurationList(apiData['storage'])
        }

        // S3 Filters
        if (apiData['storageClass'] && apiData['storageClass'].length > 0) {
          setStorageClassList(apiData['storageClass'])
        }
        if (apiData['pricingUnits'] && apiData['pricingUnits'].length > 0) {
          setStorageUnitList(apiData['pricingUnits'])
        }

        // EBS Filters
        if (apiData['storageAmountUnit'] && apiData['storageAmountUnit'].length > 0) {
          setStorageUnitList(apiData['storageAmountUnit'])
        }
        if (apiData['storageType'] && apiData['storageType'].length > 0) {
          setStorageTypeList(apiData['storageType'])
        }

        if (res['error']) {
          DebugService.error(`Price Calculator Component: Error caught while fetching ${service} filter list`, res['error'])
        }

        setIsLoading(false)
      })
      .catch(err => {
        DebugService.error(`Price Calculator Component: Error caught while fetching ${service} filter list`, err)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    setEBSTotalInstanceHours(((calculateForm['volumes'] ?? 0) * (calculateForm['volumeDuration'] ?? 0)).toFixed(2))
    fetchPriceList()
  }, [calculateForm]);

  useEffect(() => {
    setPriceList([])
    fetchFilters()
    fetchPriceList()

    setCalculateForm(prev => ({
      ...prev,
      storageAmount: service === 'EBS' ? 30 : 0,
      storageUnit: service === 'EBS' ? 'GB' : '',
    }))
  }, [service])

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Cloud Estimator`
  }, [])

  return (
    <div>
      <TopBar data-testid="top-bar-sticky" />

      {/* <div className='home-cloud-estimator-container'> */}
      <Grid container spacing={1} className='home-cloud-estimator-container'>

        <Grid item xs={12}>
          <Typography variant='h5' textAlign={'center'} color={'#203B5A'} style={{ padding: '40px 0' }}>Cloud Estimator</Typography></Grid>

        {/* Filters */}
        <Grid item xs={12} md={4}>
          <Paper elevation={3} style={{ padding: '10px' }} >
            <Grid item container spacing={1} >

              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  size="small"
                  required
                >
                  <InputLabel id="demo-simple-select-label">Service</InputLabel>
                  <Select
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Service"
                    onChange={(e) => setService(e['target']['value'])}
                    value={service}
                  >
                    {serviceList.map((s, i) => (
                      <MenuItem key={i} value={s['value']}>{s['label']}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* EC2 Filters */}
              {service === 'EC2' && (
                <Grid item container spacing={1} xs={12}>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Region</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Region"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            region: e['target']['value']
                          }
                        })}
                        value={calculateForm['region'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {regionList.length > 0 && regionList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Tenancy</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Tenancy"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            tenancy: e['target']['value']
                          }
                        })}
                        value={calculateForm['tenancy'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {tenancyList.length > 0 && tenancyList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Operating System</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Operating System"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            operatingSystem: e['target']['value']
                          }
                        })}
                        value={calculateForm['operatingSystem'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {operatingSystemList.length > 0 && operatingSystemList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">Instance Family</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Instance Family"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selInstanceFamily: e['target']['value']
                          }
                        })}
                        value={calculateForm['selInstanceFamily'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {instanceFamilyList.length > 0 && instanceFamilyList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      size="small"
                      placeholder=""
                      label="Instance Type"
                      onChange={(e) => setCalculateForm(prev => {
                        return {
                          ...prev,
                          instanceName: e['target']['value']
                        }
                      })}
                      value={calculateForm['instanceName'] || ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">vCPUs</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="vCPUs"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selVCPU: e['target']['value']
                          }
                        })}
                        value={calculateForm['selVCPU'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {vcpuList.length > 0 && vcpuList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">Memory</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Memory"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selMemory: e['target']['value']
                          }
                        })}
                        value={calculateForm['selMemory'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {memoryList.length > 0 && memoryList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">Network Performace</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Network Performace"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selNetworkPerformace: e['target']['value']
                          }
                        })}
                        value={calculateForm['selNetworkPerformace'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {networkPerformanceList.length > 0 && networkPerformanceList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              {/* RDS Filters */}
              {service === 'RDS' && (
                <Grid item container spacing={1} xs={12}>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Region</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Region"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            region: e['target']['value']
                          }
                        })}
                        value={calculateForm['region'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {regionList.length > 0 && regionList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Database Engine</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Database Engine"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            databaseEngine: e['target']['value']
                          }
                        })}
                        value={calculateForm['databaseEngine'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {databaseEngineList.length > 0 && databaseEngineList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {["Aurora PostgreSQL", "Aurora MySQL"].includes(calculateForm['databaseEngine']) && (
                    <Grid item xs={12}>
                      <FormControl
                        fullWidth
                        size="small"
                        required
                      >
                        <InputLabel id="demo-simple-select-label">Cluster Configuration</InputLabel>
                        <Select
                          labelid="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Database Engine"
                          onChange={(e) => setCalculateForm(prev => {
                            return {
                              ...prev,
                              clusterConfiguration: e['target']['value']
                            }
                          })}
                          value={calculateForm['clusterConfiguration'] || ''}
                        >
                          <MenuItem value=''>Select</MenuItem>
                          {clusterConfigurationList.length > 0 && clusterConfigurationList.map((r, i) => (
                            <MenuItem key={i} value={r}>{r}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Deployment Option</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Deployment Option"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            deploymentOption: e['target']['value']
                          }
                        })}
                        value={calculateForm['deploymentOption'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {deploymentOptionList.length > 0 && deploymentOptionList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">Instance Family</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Instance Family"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selInstanceFamily: e['target']['value']
                          }
                        })}
                        value={calculateForm['selInstanceFamily'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {instanceFamilyList.length > 0 && instanceFamilyList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">Instance Type</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Instance Type"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            rdsInstanceType: e['target']['value']
                          }
                        })}
                        value={calculateForm['rdsInstanceType'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {instanceTypeList.length > 0 && instanceTypeList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">vCPUs</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="vCPUs"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selVCPU: e['target']['value']
                          }
                        })}
                        value={calculateForm['selVCPU'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {vcpuList.length > 0 && vcpuList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-label">Memory</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Memory"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            selMemory: e['target']['value']
                          }
                        })}
                        value={calculateForm['selMemory'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {memoryList.length > 0 && memoryList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              {/* S3 Filters */}
              {service === 'S3' && (
                <Grid item container spacing={1} xs={12} className="filter-conatiner">
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Region</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Region"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            region: e['target']['value']
                          }
                        })}
                        value={calculateForm['region'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {regionList.length > 0 && regionList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Select S3 Storage Class</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Select S3 Storage Class"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            storageClass: e['target']['value']
                          }
                        })}
                        value={calculateForm['storageClass'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {storageClassList.length > 0 && storageClassList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      size="small"
                      placeholder=""
                      label="Storage"
                      onChange={(e) => setCalculateForm(prev => {
                        return {
                          ...prev,
                          storageAmount: e['target']['value']
                        }
                      })}
                      value={calculateForm['storageAmount'] || ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Unit</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Unit"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            storageUnit: e['target']['value']
                          }
                        })}
                        value={calculateForm['storageUnit'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {storageUnitList.length > 0 && storageUnitList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              {/* EBS Filters */}
              {service === 'EBS' && (
                <Grid item container spacing={1} xs={12} className="filter-conatiner">
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Region</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Region"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            region: e['target']['value']
                          }
                        })}
                        value={calculateForm['region'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {regionList.length > 0 && regionList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Storage for each EC2 instance</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Storage for each EC2 instance"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            storageType: e['target']['value']
                          }
                        })}
                        value={calculateForm['storageType'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {storageTypeList.length > 0 && storageTypeList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      size="small"
                      placeholder=""
                      label="Storage amount per volume"
                      onChange={(e) => setCalculateForm(prev => {
                        return {
                          ...prev,
                          storageAmount: parseInt(e['target']['value'] ?? 0)
                        }
                      })}
                      value={calculateForm['storageAmount'] || ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Unit</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Unit"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            storageUnit: e['target']['value']
                          }
                        })}
                        value={calculateForm['storageUnit'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        {storageUnitList.length > 0 && storageUnitList.map((r, i) => (
                          <MenuItem key={i} value={r}>{r}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      size="small"
                      placeholder=""
                      type="number"
                      label="Number of volumes"
                      onChange={(e) => setCalculateForm(prev => {
                        return {
                          ...prev,
                          volumes: parseInt(e['target']['value'] ?? 0)
                        }
                      })}
                      value={calculateForm['volumes'] || ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      size="small"
                      placeholder=""
                      label="Average duration of volume"
                      onChange={(e) => setCalculateForm(prev => {
                        return {
                          ...prev,
                          volumeDuration: parseInt(e['target']['value'] ?? 0)
                        }
                      })}
                      value={calculateForm['volumeDuration'] || ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      required
                    >
                      <InputLabel id="demo-simple-select-label">Volume Unit</InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Volume Unit"
                        onChange={(e) => setCalculateForm(prev => {
                          return {
                            ...prev,
                            volumeDurationUnit: e['target']['value']
                          }
                        })}
                        value={calculateForm['volumeDurationUnit'] || ''}
                      >
                        <MenuItem value=''>Select</MenuItem>
                        <MenuItem value={'hours per month'}>hours per month</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  title='Reset'
                  onClick={() => {
                    onReset()
                  }}
                  className="reset-button"
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Table */}
        <Grid item xs={12} md={8}>
          <Paper elevation={3}>
            {['RDS', 'EC2'].includes(service) && (
              <DataGridTable
                evenRowColor={'#425466'}
                columnVisibilityModel={{ id: false }}
                columns={service === 'EC2' ? ec2ColumnList : rdsColumnList}
                rows={priceList}
                showTooltip={false}
                showPagination={true}
                hideExport={true}
              />
            )}

            {service === 'S3' && calculateForm['storageClass'] !== '' && (
              <Card component={Paper} elevation={3}>
                <CardContent>
                  <Typography color={'#36454F'}>Tiered price for: {calculateForm['storageAmount']} {calculateForm['storageUnit']}</Typography>
                  <Typography color={'#36454F'}>{calculateForm['storageAmount']} {calculateForm['storageUnit']} x {storageOnDemandCost} USD = {storageOnDemandMonthlyCost} USD</Typography>
                  <Typography color={'#36454F'}>Total tier cost = {storageOnDemandCost} USD ({calculateForm['storageClass']})</Typography>
                  <Typography color={'#36454F'} fontWeight={'bold'}>{calculateForm['storageClass']} (monthly): {storageOnDemandMonthlyCost} USD</Typography>
                </CardContent>
              </Card>
            )}

            {service === 'EBS' && (
              <Card component={Paper} elevation={3}>
                <CardContent>
                  <Typography color={'#36454F'}>{calculateForm['volumes']} volumes x {calculateForm['volumeDuration']} instance hours = {EBSTotalInstanceHours} total instance hours</Typography>
                  <Typography color={'#36454F'}>{EBSTotalInstanceHours} instance hours / {calculateForm['volumeDuration']} hours in a month = {calculateForm['volumes'].toFixed(2)} instance months</Typography>
                  <Typography color={'#36454F'}>{EBSStorage} GB x {calculateForm['volumes'].toFixed(2)} instance months x {EBSOndemandCost} USD = {EBSStorageCost} USD (EBS Storage Cost)</Typography>
                  <Typography fontWeight={'bold'} color={'#36454F'}>EBS Storage Cost: {EBSStorageCost} USD</Typography>
                  <Typography fontWeight={'bold'} color={'#36454F'}>Amazon Elastic Block Storage (EBS) total cost (monthly): {EBSStorageCost} USD</Typography>
                </CardContent>
              </Card>
            )}
          </Paper>
        </Grid>

      </Grid>
      {/* </div> */}

      <Footer />
    </div>
  )
}
